import { AIconProps, AIconSize } from '../../atoms/AIcon/AIcon.types';
import { AImageProps } from '../../atoms/AImage/AImage.types';
import { MLogoContainerSize } from '../MLogoContainer/MLogoContainer.types';
import { DACImage } from '../../utils/ImageUtils';

export enum MBrandElementType {
  Logo = 'Logo',
  Icon = 'Icon',
  Image = 'Image',
}

export interface ALogo32Props {
  brand: string;
  color?: 'color' | 'background-aware';
}

export interface MBrandElementProps {
  type: MBrandElementType;
  logoSize?: MLogoContainerSize;

  /** New AEM-aligned prop for the Icon variant. Takes precedence over legacy `icon`/`iconSize`. */
  aIcon?: Pick<AIconProps, 'icon' | 'size'>;
  /** New AEM-aligned prop for the Image variant. Takes precedence over legacy `image`. */
  aImage?: Pick<AImageProps, 'image'>;
  /** New AEM-aligned prop for the Logo variant. Takes precedence over legacy `brand`/`logoColor`. */
  mLogoContainer?: { aLogo32?: ALogo32Props };

  /** @deprecated Use `aIcon.size` instead. */
  iconSize?: AIconSize;
  /** @deprecated Use `aIcon.icon` instead. */
  icon?: string;
  /** @deprecated Use `aImage` instead. */
  image?: DACImage;
  /** @deprecated Use `mLogoContainer.aLogo32.brand` instead. */
  brand?: string;
  /** @deprecated Use `mLogoContainer.aLogo32.color` instead. */
  logoColor?: 'background-aware' | 'color';
}
